import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from './views/Home.vue';
import ChooseGame from './views/ChooseGame.vue';
import Game from './views/Game.vue';
import GameRedirect from './views/GameRedirect.vue';
import GameHomeRedirect from './views/GameHomeRedirect.vue';
import Profile from './views/Profile.vue';
import Login from './views/Login.vue';
import Learn from './views/Learn.vue';
import Leaderboard from './views/Leaderboard.vue';
import Signup from './views/Signup.vue';
import Forgot from './views/Forgot.vue';
// import Reset from './views/Reset.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'chooseGame',
    component: ChooseGame,
  },
  {
    path: '/:game_slug/learn',
    name: 'learn',
    component: Learn,
  },
  {
    path: '/:game_slug/leaderboard',
    name: 'leaderboard',
    component: Leaderboard,
  },
  {
    path: '/choose_game/:game_slug',
    name: 'chooseGame',
    component: GameHomeRedirect,
  },
  {
    path: '/tafl',
    name: 'tafl',
    component: Home,
  },
  {
    path: '/pentago',
    name: 'pentago',
    component: Home,
  },
  {
    path: '/reversi',
    name: 'reversi',
    component: Home,
  },
  {
    path: '/p/:username',
    name: 'profile',
    component: Profile,
  },
  {
    path: '/games/:game_id',
    name: 'game',
    component: Game,
  },
  {
    path: '/create_game/:game_id',
    name: 'gameRedirect',
    component: GameRedirect,
  },
  {
    meta: {
      auth: false,
    },
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    meta: {
      auth: false,
    },
    path: '/signup',
    name: 'Signup',
    component: Signup,
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: Forgot,
  },
  // {
  //   path: '/reset/:code',
  //   name: 'Reset',
  //   component: Reset,
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
